/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brands_Futaroku_HrefInputs */

const ja_home_brands_futaroku_href = /** @type {(inputs: Home_Brands_Futaroku_HrefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://futaroku.gg`)
};

const en_home_brands_futaroku_href = /** @type {(inputs: Home_Brands_Futaroku_HrefInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`https://futaroku.gg`)
};

/**
* | output |
* | --- |
* | "https://futaroku.gg" |
*
* @param {Home_Brands_Futaroku_HrefInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const home_brands_futaroku_href = /** @type {((inputs?: Home_Brands_Futaroku_HrefInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brands_Futaroku_HrefInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_brands_futaroku_href(inputs)
	return en_home_brands_futaroku_href(inputs)
});